import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { takeWhile } from 'rxjs/operators';
import { DEFAULT_LANGUAGE } from '@ibe.config';
var INDRARadioInputGroupComponent = /** @class */ (function () {
    function INDRARadioInputGroupComponent(ibeAdminService, paymentService) {
        this.ibeAdminService = ibeAdminService;
        this.paymentService = paymentService;
        this._value = '';
        this.inline = false;
        this.optionChanged = new EventEmitter();
        this.propagateChange = function (_) { };
        this.isAlive = true;
        this.triedToSubmit = false;
        this.allSubscriptions = [];
    }
    Object.defineProperty(INDRARadioInputGroupComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            this._value = val;
            this.propagateChange(this._value);
        },
        enumerable: true,
        configurable: true
    });
    INDRARadioInputGroupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.submitSubsription = this.ibeAdminService.loadTranslations("tap", ["shoppingBasket"], (sessionStorage.getItem('language') ? sessionStorage.getItem('language') : DEFAULT_LANGUAGE));
        this.paymentService.triedToSubmit
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (triedToSubmit) {
            _this.triedToSubmit = triedToSubmit;
        });
        this.allSubscriptions.push(this.submitSubsription);
    };
    INDRARadioInputGroupComponent.prototype.trackByRadioId = function (radioBttn) {
        return radioBttn.id;
    };
    INDRARadioInputGroupComponent.prototype.onRadioChange = function (event) {
        var activeOption = null;
        this.options.forEach(function (option) {
            if (!event[option.id]) {
                option['selected'] = false;
            }
            else {
                activeOption = option.id;
                option['selected'] = true;
            }
        });
        this.optionChanged.emit(activeOption);
    };
    INDRARadioInputGroupComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    INDRARadioInputGroupComponent.prototype.registerOnTouched = function (fn) { };
    INDRARadioInputGroupComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    INDRARadioInputGroupComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    return INDRARadioInputGroupComponent;
}());
export { INDRARadioInputGroupComponent };
